import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

export const searchFields: SearchProps = {
  show_errors: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_errors',
    caption: 'Show errors?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
  show_ignored: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_ignored',
    caption: 'Show ignored?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
};

export default searchFields;
